import { useState } from 'react';
import Table from '@/components/table/components/Table.tsx';
import { RowContextMenuItemParams } from '@/components/table/components/RowContextMenu.tsx';
import { confirmDialogUseHook } from '@/components/ui/ConfirmDialog.useHook.ts';
import insurancesApi from '@/features/dashboard/insurances/api/insurancesApi.ts';
import { insurancesApiQueryKeys } from '@/features/dashboard/insurances/api/insurancesApi.queryKeys.ts';
import { InsuranceListDto } from '@/features/dashboard/insurances/types/InsuranceListDto.ts';
import useDeleteInsurance from '@/features/dashboard/insurances/hooks/useDeleteInsurance.ts';
import EditInsuranceModal from '@/features/dashboard/insurances/components/EditInsuranceModal.tsx';

const InsuranceTypesTable = () => {
  const [editInsuranceId, setEditInsuranceId] = useState<string | null>(null);
  const deleteMutation = useDeleteInsurance();
  const { confirmDeleteWithCallback } = confirmDialogUseHook();

  const rowContextMenuItems: RowContextMenuItemParams<InsuranceListDto>[] = [
    {
      label: 'Edytuj',
      action: (row) => setEditInsuranceId(row.id),
    },
    {
      label: 'Usuń',
      variant: 'destructive',
      action: (row) =>
        confirmDeleteWithCallback({
          title: 'Usuń ubezpieczenie',
          description: (
            <>
              Czy na pewno chcesz usunąć ubezpieczenie <b>{row.name}</b>?
            </>
          ),
          confirmText: 'Usuń ubezpieczenie',
          loadingText: 'Usuwanie...',
          onConfirm: () => deleteMutation.mutate(row.id),
        }),
    },
  ];

  return (
    <>
      <Table
        queryKey={insurancesApiQueryKeys.all()}
        fetchData={insurancesApi.getAll}
        fetchTableDef={insurancesApi.getTableDefinition}
        rowContextMenuItems={rowContextMenuItems}
      />

      {editInsuranceId && (
        <EditInsuranceModal
          insuranceId={editInsuranceId}
          onClose={() => setEditInsuranceId(null)}
        />
      )}
    </>
  );
};

export default InsuranceTypesTable;
